import React, { useEffect } from "react";
import moment from "moment";
import Sign from "../../../image/ramesh_sign.png";
import Stamp from "../../../image/aditvertasstamp.png";
import LastPageStamp from "../../../image/lastpagesign.png";
import { useLocation, useParams } from "react-router-dom";
import { fetchQuery } from "../../../../utils/commonComponent/fetched";
import { generateCoverLetterPdf } from "../coverLetterPrint";
import { AddButton, CancelButton, SaveAndUpdate } from "../../../../utils/Custom/Button";
import axiosWithToken from "../../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../../global";
import { toast } from "react-toastify";
import Text from "../../../../utils/Custom/text";
import { AutoCompletes, DateInput, TextFields } from "../../../../utils/Custom/custominput";
import { format } from "date-fns";
import AddTable from "../../../dynamicTables/dynamicTable";
import { extractBodyRows, extractHeaders, groupTableData } from "../../../../utils/commonComponent/tableUtils";
import DownloadPdfLoaderModal from "../../../../utils/commonComponent/downloadPdfLoader";
import { getPermissions } from "../../rbac/hasAccess";

const CreateCoverLetter = (props) => {
  const margin = "px-6 md:px-20";
  const sectionGap = "mb-8";
  const lineGap = "mb-2 font-bold";
  const boldText = "font-bold";
  const centeredText = "text-center";

  const params = useParams();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const isQRRoute = location.pathname.includes("/createReport/print/qr/");
  const PrintView = props?.print == true;
  // const [suppliers, setSuppliers] = React.useState([]);
  const [inputStates, setInputStates] = React.useState({});
  const [IRDetails, setIRDetails] = React.useState({});
  const [referenceDocs, setReferenceDocs] = React.useState([]);
  const [tableData, setTableData] = React.useState([]);
  const [inpectorList, setinpectorList] = React.useState([]);
  const [downloadPdfloading, setDownloadPdfloading] = React.useState(false);

  const fetchCoverLetterDetails = async () => {
    try {
      const query = `SELECT IR_coverLetter.*, u.userSign AS inspectedBySign, emp.name AS inspectedByName FROM IR_coverLetter LEFT JOIN users u ON IR_coverLetter.inspectorId = u.id LEFT JOIN employees emp ON u.employeeId = emp.id WHERE IR_coverLetter.id = ${params.id}`;
      const [coverLetterData] = await fetchQuery(query);
      if (coverLetterData) {
        setInputStates(coverLetterData);
      }
    } catch (error) {
      console.error("Error fetching cover letter details:", error);
    }
  };

  const fieldCharLimits = {
    clientId: 225,                   // 250 
    subjet: 450,                     // 500 
    reference: 450,                  // 500 
    introduction: 900,               // 1000

    referenceDoc: 450,               // 500 
    inspectionDetails: 1600,         // 1700
    documentReview: 450,             // 500 
    inspectionIdentification: 450,   // 500 
  }

  const updateInputObject = (key, value) => {
    const Limit = fieldCharLimits[key];
    if (Limit && typeof value === "string" && value.length > Limit) {
      toast.warning(`You have reached the maximum ${Limit} allowed text limit`);
      return;
    }
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  // Function to delete existing table data from server
  const deleteExistingTableData = async (jobInspectionId) => {
    try {
      await Promise.all([
        axiosWithToken.post(`${BASE_URL}dynamic`, {
          query: `DELETE FROM dynamicTableHeader WHERE type = 2 AND jobInspectionId = ${jobInspectionId};`,
        }),
        axiosWithToken.post(`${BASE_URL}dynamic`, {
          query: `DELETE FROM dynamicTableBody WHERE type = 2 AND jobInspectionId = ${jobInspectionId};`,
        }),
      ]);
    } catch (error) {
      console.error("Error deleting existing table data:", error);
    }
  };

  const onSubmit = async () => {
    try {
      const { companyName, inspectedBySign, inspectedByName, mode, ...restInputStates } = inputStates;

      // Prepare payload, excluding companyName and adding mode
      const payload = {
        ...restInputStates,
        mode: 1, // create manually
        workName: inputStates.workName || inputStates.subjet || null,
        issueDate: moment(inputStates?.issueDate).format("YYYY-MM-DD") || null,
        createdBy: localStorage.getItem("id"),
      };

      const url = `${BASE_URL}IR_coverLetter`;
      let insertedId = params.id;

      if (params.id == 0) {
        const res = await axiosWithToken.post(url, payload);
        insertedId = res?.data?.insertId;
      } else {
        await axiosWithToken.patch(`${url}/${params.id}`, payload);
        await deleteExistingTableData(params.id);
      }

      // Save dynamic table data
      if (tableData.length > 0) {
        const allHeaders = [];
        const allBody = [];

        tableData.forEach((table) => {
          allHeaders.push(...extractHeaders(table, parseInt(insertedId), 2));
          allBody.push(...extractBodyRows(table, parseInt(insertedId), 2));
        });

        if (allHeaders.length) {
          await axiosWithToken.post(
            `${BASE_URL}dynamicTableHeader/bulk`,
            allHeaders
          );
        }
        if (allBody.length) {
          await axiosWithToken.post(
            `${BASE_URL}dynamicTableBody/bulk`,
            allBody
          );
        }
      }

      toast.success(
        params.id === "0" ? "Cover letter created!" : "Updated successfully!"
      );
      setTimeout(() => window.location.reload(), 500);
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  // Fetch dynamic table data
  const fetchTableData = async () => {
    try {
      if (params.id && params.id !== "0") {
        const [headers, bodyData] = await Promise.all([
          fetchQuery(
            `SELECT * FROM dynamicTableHeader WHERE type = 2 AND jobInspectionId = ${params.id}`
          ),
          fetchQuery(
            `SELECT * FROM dynamicTableBody WHERE type = 2 AND jobInspectionId = ${params.id}`
          ),
        ]);

        if (headers.length > 0) {
          const grouped = groupTableData(
            headers,
            bodyData,
            parseInt(params.id)
          );
          setTableData(grouped);
        }
      }
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  const fetchinpectorsList = async () => {
    // const query = `SELECT * FROM users WHERE status = 1  ORDER BY id DESC`;
    const query = 'SELECT u.*, emp.name AS inspectorName FROM users u LEFT JOIN employees emp ON u.employeeId = emp.id WHERE u.status = 1 AND u.type = 2 ORDER BY u.id DESC;';
    const res = await fetchQuery(query);
    const modified = res?.map((item) => ({
      ...item,
      label: `${item.inspectorName} (${item.userName})`,
    }))
    setinpectorList(modified);
  };

  // useEffect(() => {
  //   const fetchSuppliers = async () => {
  //     const data = await fetchQuery(`SELECT c.companyName, a.address FROM clients c LEFT JOIN addresses a ON a.id = c.address WHERE c.status = 1`);
  //     setSuppliers(data);
  //   };

  //   fetchSuppliers();
  // }, []);

  useEffect(() => {
    fetchTableData();
    fetchinpectorsList();
  }, []);

  useEffect(() => {
    if (params.id == 0) {
      updateInputObject("remarks", "Inspection was carried out as per the referred Specifications, the items meet the requirement of the work order specification and quality Control plan.");
    } else {
      fetchCoverLetterDetails();
    }
  }, [params.id]);
  useEffect(() => {
    if (params.id == 0) {
      updateInputObject("certificateNo", inputStates.reportNo);
    }
  }, [params.id, inputStates.reportNo]);

  // Auto-download PDF for QR route
  useEffect(() => {
    if (isQRRoute && inputStates.id) {
      // Wait a bit for all data to load
      const timer = setTimeout(() => {
        generateCoverLetterPdf(IRDetails, referenceDocs, inputStates, tableData, setDownloadPdfloading)
      }, 1500); // 1.5 seconds delay to ensure data is loaded
      return () => clearTimeout(timer);
    }
  }, [isQRRoute, inputStates.id]);

  return (
    <div className={isQRRoute ? "p-8" : ""} style={{ width: "100%" }}>
      {(permissions.pdfDownload || permissions.allAccess) && PrintView && !isQRRoute && (
        <>
          <div className="flex gap-5 justify-end ">
            <AddButton
              id="btn-add-outline"
              label="Download Cover Letter"
              onClick={() =>
                generateCoverLetterPdf(IRDetails, referenceDocs, inputStates, tableData, setDownloadPdfloading)
              }
            />
          </div>
        </>
      )}

      <br />
      {!PrintView && (
        <Text variant="h3" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
          Cover Letter Details
        </Text>
      )}

      {!PrintView && (
        <>
          <div className="flex gap-5">
            <TextFields
              label="Report Number"
              value={inputStates.reportNo || ""}
              onChange={(e) => updateInputObject("reportNo", e.target.value)}
              multiline
              minRows={1}
              maxRows={10}
            />
            <TextFields
              label="Certificate Number"
              value={inputStates.certificateNo || ""}
              onChange={(e) => updateInputObject("certificateNo", e.target.value)}
              multiline
              minRows={1}
              maxRows={10}
            />

            <DateInput
              id="issue-date"
              label={"Issue Date"}
              value={inputStates.issueDate ? new Date(inputStates.issueDate) : ""}
              onChange={(date) => {
                const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
                updateInputObject("issueDate", formattedDate);
              }}
            />
          </div>
          <br />

          <TextFields
            label="Client"
            value={inputStates.clientId || ""}
            onChange={(e) => updateInputObject("clientId", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label="Subject"
            value={inputStates.subjet || ""}
            onChange={(e) => updateInputObject("subjet", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label="Reference"
            value={inputStates.reference || ""}
            onChange={(e) => updateInputObject("reference", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label="Introduction"
            value={inputStates.introduction || ""}
            onChange={(e) => updateInputObject("introduction", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />

          <AddTable
            tables={tableData}
            setTables={setTableData}
            jobInspectionId={params.id}
            type={2}
          />

          {!PrintView && (
            <Text variant="h3" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
              Release Note
            </Text>
          )}

          <TextFields
            label={"Contractor Consignee"}
            value={inputStates.contractorClient || ""}
            onChange={(e) =>
              updateInputObject("contractorClient", e.target.value)
            }
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Contractor Name"}
            value={inputStates.contractorConsignee || ""}
            onChange={(e) =>
              updateInputObject("contractorConsignee", e.target.value)
            }
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Name of Manufacturer / Supplier"}
            value={inputStates.supplierName || ""}
            onChange={(e) => updateInputObject("supplierName", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          {/* <AutoCompletes
            label="Name of Manufacturer / Supplier"
            options={suppliers.map((s) => ({
              ...s,
              displayValue: `${s.companyName}, ${s.address}`,
            }))}
            labelKey="displayValue"
            valueKey="displayValue"
            value={inputStates.supplierName || ""}
            onChange={(val) => updateInputObject("supplierName", val)}
            isWidth
          /> */}
          <br />
          <TextFields
            label={"Work Name"}
            value={inputStates.workName || inputStates.subjet || ""}
            onChange={(e) => updateInputObject("workName", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Reference Documents"}
            value={inputStates.referenceDoc || ""}
            onChange={(e) => updateInputObject("referenceDoc", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Inspection Details"}
            value={inputStates.inspectionDetails || ""}
            onChange={(e) =>
              updateInputObject("inspectionDetails", e.target.value)
            }
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Documents Reviewed/Enclosed"}
            value={inputStates.documentReview || ""}
            onChange={(e) =>
              updateInputObject("documentReview", e.target.value)
            }
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Remarks"}
            value={inputStates.remarks || ""}
            onChange={(e) => updateInputObject("remarks", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Remarks2"}
            value={inputStates.remarks2 || ""}
            onChange={(e) => updateInputObject("remarks2", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Inspection Identification"}
            value={inputStates.inspectionIdentification || ""}
            onChange={(e) =>
              updateInputObject("inspectionIdentification", e.target.value)
            }
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <AutoCompletes
            label="Select Inspector"
            options={inpectorList}
            value={inputStates.inspectorId || ""}
            onChange={(val) => updateInputObject("inspectorId", val)}
            isWidth
            valueKey="id"
            labelKey="label"
          />
          <br />
          <AutoCompletes
            label="Order Status"
            options={[
              { id: 1, label: "Complete" },
              { id: 2, label: "InComplete" },
              { id: 3, label: "Progress" },
            ]}
            value={inputStates.orderStatus || ""}
            onChange={(val) => updateInputObject("orderStatus", val)}
            isWidth
            valueKey="label"
            labelKey="label"
          />
          <br />
          <br />
        </>
      )}

      {PrintView && (
        <div className={`text-sm font-sans ${margin} py-12 text-justify`}>
          {/* Header Section */}
          <h1 className={`${centeredText} text-lg font-bold mb-8`}>
            COVER LETTER
          </h1>

          {/* Ref and Date */}
          <div className="flex justify-between">
            <p>
              <strong>{inputStates?.reportNo}</strong>
            </p>
            <p>
              <strong>
                Date: {moment(inputStates?.issueDate).format("DD/MM/YYYY")}
              </strong>
            </p>
          </div>

          {/* Address To */}
          <div className={`${sectionGap}`}>
            <p className={lineGap}>To,</p>
            <pre className={lineGap}>{inputStates?.clientId}</pre>
          </div>

          {/* Subject */}
          <div className={`${sectionGap}`}>
            <p className={`${boldText}`}>Subject:</p>
            <p>{inputStates?.subjet}</p>
          </div>

          {/* Reference */}
          <div className={`${sectionGap}`}>
            <p className={`${boldText}`}>Reference:</p>
            <p>{inputStates?.reference}</p>
          </div>

          <p className={`${boldText} ${lineGap}`}>Dear Sir,</p>

          <p className={`${sectionGap}`}>{inputStates?.introduction}</p>

          {/* Dynamic Table Section */}
          {tableData.length > 0 && tableData[0].body.length > 0 && (
            <div className={`${sectionGap} overflow-x-auto`}>
              <table className="table-auto border-collapse border border-black w-full text-center">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-black p-2">Sr.No.</th>
                    {tableData[0].columns.map((column, index) => (
                      <th key={column.id} className="border border-black p-2">
                        {column.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData[0].body.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td className="border border-black p-2">
                        {rowIndex + 1}
                      </td>
                      {tableData[0].columns.map((column) => (
                        <td key={column.id} className="border border-black p-2">
                          {row[column.accessor] || ""}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Remarks */}
          <div className={`${sectionGap}`}>
            <p className={lineGap}>
              The inspection report for the same are attached herewith for your
              reference and dispatch clearance has been given for the quantity
              mentioned above.
            </p>
            <p className={lineGap}>Thanking you.</p>
          </div>

          {/* Images */}
          <div className="flex justify-between mt-10">
            <img src={Stamp} alt="Stamp" className="w-40 h-20" />
            <img src={Sign} alt="Sign" className="w-40 h-20" />
          </div>
          <h4 className="text-right mt-5 mr-2 pr-5 font-bold">Ramesh S. Jadhav</h4>
          <h4 className="text-right mt-2 mr-2 pr-5 font-bold">For BFI</h4>

          {/* Contractor Details Section */}
          <div className="mt-20">
            <h2 className="text-center font-bold mb-2 text-base">
              INSPECTION CERTIFICATE/RELEASE NOTE
            </h2>
            <p className="text-center mb-6 font-bold">
              [CERTIFICATE NO. {inputStates?.certificateNo || inputStates?.reportNo} Date: {moment(inputStates?.issueDate).format("DD/MM/YYYY")}]
            </p>

            <table className="table-auto border border-black w-full text-left">
              <tbody>
                <tr>
                  <td className="border border-black p-2 font-semibold w-1/3">
                    Contractor Consignee
                  </td>
                  <td className="border border-black p-2 text-center w-10">
                    :
                  </td>
                  <td className="border border-black p-2">
                    {inputStates?.contractorClient || ""}
                  </td>
                </tr>
                <tr>
                  <td className="border border-black p-2 font-semibold">
                    Contractor Name
                  </td>
                  <td className="border border-black p-2 text-center">:</td>
                  <td className="border border-black p-2">
                    {inputStates?.contractorConsignee || ""}
                  </td>
                </tr>
                <tr>
                  <td className="border border-black p-2 font-semibold">
                    Name of Manufacturer/Supplier
                  </td>
                  <td className="border border-black p-2 text-center">:</td>
                  <td className="border border-black p-2">
                    {inputStates?.supplierName}
                  </td>
                </tr>
                <tr>
                  <td className="border border-black p-2 font-semibold">
                    Work Name
                  </td>
                  <td className="border border-black p-2 text-center">:</td>
                  <td className="border border-black p-2">
                    {inputStates?.workName}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Inspection Details Section */}
          <div className="mt-12 space-y-4">
            <div>
              <h3 className="font-bold mb-1">REFERENCE DOCUMENTS:</h3>
              <pre className="whitespace-pre-wrap break-words">{inputStates.referenceDoc}</pre>
            </div>

            <div>
              <h3 className="font-bold mb-1">INSPECTION DETAILS:-</h3>
              <pre className="whitespace-pre-wrap break-words">{inputStates.inspectionDetails}</pre>
            </div>

            <div>
              <h3 className="font-bold mb-1">DOCUMENTS REVIEWED/ENCLOSED:-</h3>
              <p className="mb-1">Found satisfactory for all Pipes.</p>
              <pre className="whitespace-pre-wrap break-words">{inputStates.documentReview}</pre>
            </div>

            <div>
              <h3 className="font-bold mb-1">
                REMARKS :-
                <span className="font-semibold ml-2">{inputStates?.remarks}</span>
              </h3>
              <h3 className="font-bold mb-1">
                <span className="font-semibold ml-2">{inputStates?.remarks2}</span>
              </h3>
            </div>

            <div>
              <h3 className="font-bold mb-1">
                INSPECTION IDENTIFICATION :-
                <span className="font-semibold ml-2">
                  {inputStates?.inspectionIdentification}
                </span>
              </h3>
            </div>

            <div>
              <h3 className="font-bold mb-1">
                Order Status :-
                <span className="font-semibold ml-2">
                  {inputStates?.orderStatus}
                </span>
              </h3>
            </div>
          </div>
          <div className="flex justify-between mt-10">
            <img src={Stamp} alt="Stamp" className="w-40 h-20" />
            <img
              src={inputStates?.inspectedBySign}
              alt="LastPageStamp"
              className="w-40 h-20"
            />
          </div>
          <h4 className="text-right mt-5 mr-2 pr-5 font-bold">{inputStates?.inspectedByName || ""}</h4>
          <h4 className="text-right mt-5 mr-2 pr-5 font-bold">Inspection Engineer</h4>
        </div>
      )}

      {!PrintView && (
        <div className="flex gap-10 mt-5 justify-end ">
          <CancelButton
            id="btn-cancel"
            label="Cancel"
            outline
            onClick={() => {
              if (window.confirm("Are you sure you want to cancel?")) {
                window.history.back();
              }
            }}
          />
          {(permissions.save || permissions.create || permissions.allAccess) && (
            <SaveAndUpdate
              id="btn-add-outline"
              label={"Save"}
              onClick={onSubmit}
            />
          )}
        </div>
      )}

      {downloadPdfloading && (
        <DownloadPdfLoaderModal
          loading={downloadPdfloading}
          name={"Cover Letter"}
        />
      )}
    </div>
  );
};

export default CreateCoverLetter;
